import axios from "../axios";

const END_POINT = "/reception-services";

const addReceptionServices = (reception) => axios.post(`${END_POINT}`, reception);
const updateDiscountGroup = (reception) => axios.post(`${END_POINT}/update-discount-group`, reception);
const getReceptionServices = (receptionId) => axios.get(`${END_POINT}/get-by-reception-id/${receptionId}`);
const startDoctorPresence = (serviceId) => axios.get(`${END_POINT}/present-doctor/${serviceId}`);
const endDoctorPresence = (serviceId) => axios.get(`${END_POINT}/complete-presence-doctor/${serviceId}`);
const deleteReceptionService = (payload) => axios.delete(`${END_POINT}/remove/${payload.receptionId}/${payload.receptionServiceId}`);

export {
    addReceptionServices, getReceptionServices, startDoctorPresence, endDoctorPresence, deleteReceptionService, updateDiscountGroup
}